import { Pipe, PipeTransform } from '@angular/core';
import { RootSalary } from '../../models/salary/rootsalary.model';

/*
* Pipe for sorting individual columns in table in ascending or descending order
*/

@Pipe({ name: 'sort' })
export class SortPipe implements PipeTransform {
  transform(salary: RootSalary[], direction: string, column: string, type: string) {
    let sortedItems = [];
    sortedItems =
      direction === 'asc'
        ? this.sortAscending(salary, column, type)
        : this.sortDescending(salary, column, type);
    return sortedItems;
  }
  sortAscending(salary: RootSalary[], column: string, type: string) {
    return [
      ...salary.sort(function (a: any, b: any) {
        if (type === 'string') {
          if (a[column].toUpperCase() < b[column].toUpperCase()) { return -1; }
        } else {
          return a[column] - b[column];
        }
      }),
    ];
  }
  sortDescending(salary: RootSalary[], column: string, type: string) {
    return [
      ...salary.sort(function (a: any, b: any) {
        if (type === 'string') {
          if (a[column].toUpperCase() > b[column].toUpperCase()) { return -1; }
        } else {
          return b[column] - a[column];
        }
      }),
    ];
  }
}
